<template>
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span>Subscription plans</span>
              </li>
            </ol>
          </div>
          <h2 class="font-light m-b-xs">
            Subscription plans
          </h2>
          <small>No obligations. You can change your plan anytime.</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row">
        <div class="col-lg-12">
          <template v-if="paymentStatus === false && selectedPlan === null && selectedProduct === null">

            <div class="row">
              <div class="col-xs-12 text-center" style="margin-bottom: 15px">
                <h3 v-if="selectedPlan === null">Step 1/2: choose your plan</h3>
              </div>

              <div class="col-xs-12">
                <div class="" :class="{hpanel : !$user.isSme()}">
                  <ul class="nav nav-tabs" style="font-size: 16px" v-if="!$user.isSme()">
                    <li class="active"  style="width: 33%" v-if="($user.isIdexlab() && !$user.isBusiness() && !$user.isCorporate() && !$user.isExpected()) || ($user.isSme() && !$user.isExpected())">
                      <a data-toggle="tab" href="#tab-1" aria-expanded="true" class="text-center" @click="tabSelected = 'Individual'"> <i class="fa fa-user text-info"></i> For individuals & small enterprises</a>
                    </li>
                    <li style="width: 33%" :class="{active: !$user.isIdexlab() || (!$user.isCorporate() && $user.isExpected()) || $user.isBusiness()}" v-if="!$user.isCorporate()">
                      <a data-toggle="tab" href="#tab-2" aria-expanded="false" class="text-center" @click="tabSelected = 'Business'"> <i class="fa fa-users text-info"></i> For teams & companies</a>
                    </li>
                    <li  style="width: 33%" :class="{active: $user.isCorporate() && !$user.isSme()}" v-if="!$user.isSme()">
                      <a data-toggle="tab" href="#tab-3" aria-expanded="false" class="text-center" @click="tabSelected = 'Corporate'"> <i class="fa fa-users text-info"></i> For corporate</a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div id="tab-1" class="tab-pane active" v-if="($user.isIdexlab() && !$user.isBusiness() && !$user.isCorporate() && !$user.isExpected()) || ($user.isSme() && !$user.isExpected())">
                      <div class="panel-body" >
                          <product-selection-individual v-if="tabSelected === 'Individual'" @updateSelectedPlan="updateSelectedPlan"
                                                        @updateSelectedProduct="updateSelectedProduct"></product-selection-individual>
                      </div>
                    </div>
                    <div v-if="!$user.isSme()" id="tab-2" class="tab-pane" :class="{active: $auth.user().profile.id !== 1 || $user.isBusiness() || $user.isExpected()}">
                      <div class="panel-body" >

                        <product-selection-business v-if="tabSelected === 'Business'"></product-selection-business>
                      </div>
                    </div>
                    <div v-if="!$user.isSme()" id="tab-3" class="tab-pane" :class="{active: $auth.user().profile.id !== 1 || $user.isCorporate()}">
                      <div class="panel-body" >

                        <product-selection-corporate v-if="tabSelected === 'Corporate'"></product-selection-corporate>
                      </div>
                    </div>

                  </div>

                </div>

              </div>

            </div>
          </template>
<!--          <template v-else-if="paymentStatus === null && selectedPlan !== null && selectedProduct !== null">-->
<!--            <div class="row">-->
<!--              <div class="col-xs-12 text-center" style="margin-bottom: 15px">-->
<!--                <h3>Step 2/3: Summary</h3>-->
<!--              </div>-->
<!--            </div>-->
<!--            <summary-plan :plan="selectedPlan" v-model="paymentStatus"></summary-plan>-->
<!--          </template>-->
          <template v-else>
            <div class="row">
              <div class="col-xs-12 text-center" style="margin-bottom: 15px">
                <h3 v-if="paymentStatus !== false || (selectedPlan !== null && selectedPlan.productObject.name === 'Basic')">Step 2/2: Change of plan</h3>
                <h3 v-else-if="paymentStatus === false">Step 2/2: Validate your payment</h3>
              </div>
            </div>

            <payment :paymentStatus="paymentStatus" :plan="selectedPlan"></payment>
          </template>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import ProductSelectionIndividual from './ProductSelectionIndividual'
import ProductSelectionBusiness from './ProductSelectionBusiness'
import ProductSelectionCorporate from './ProductSelectionCorporate'
import Payment from './Payment'
import SummaryPlan from './SummaryPlan'

export default {
  components: {
    SummaryPlan,
    ProductSelectionIndividual,
    ProductSelectionBusiness,
    ProductSelectionCorporate,
    Payment
  },
  name: 'Plans',
  data () {
    return {
      paymentStatus: false,
      selectedProduct: null,
      selectedPlan: null,
      tabSelected: ''
    }
  },
  methods: {
    updateSelectedPlan: function (plan) {
      this.selectedPlan = plan
    },
    updateSelectedProduct: function (product) {
      this.selectedProduct = product
    }
  },
  updated () {
    if (typeof this.$route.query.paymentStatus !== 'undefined') {
      this.paymentStatus = Boolean(this.$route.query.paymentStatus)
    }
  },
  beforeMount () {
    if (typeof this.$route.query.paymentStatus !== 'undefined') {
      this.paymentStatus = Boolean(this.$route.query.paymentStatus)
    }
    this.$salesMachine.visitSubscriptionPlan()

    if (this.$user.isSme() && !this.$user.isExpected()) {
      this.tabSelected = 'Individual'
    } else if (this.$user.isBusiness() || (this.$auth.user().profile.id !== 1 && !this.$user.isCorporate()) || this.$user.isExpected()) {
      this.tabSelected = 'Business'
    } else if (this.$user.isCorporate()) {
      this.tabSelected = 'Corporate'
    } else {
      this.tabSelected = 'Individual'
    }
    if (this.selectedPlan !== null || this.selectedProduct !== null) {
      $('body').removeClass('hide-sidebar').addClass('hide-sidebar')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/plan/Plans.vue